/* Scroll-loaded Google Map for sections/pj_store-local.liquid.
   The iframe is created the first time the block nears the viewport, so the
   map never sits on the critical path of a page view and a visitor who does
   not scroll that far never loads it. Trade-off accepted per Alex 2026-09-21:
   a visitor who DOES scroll there reaches Google without an explicit action,
   so no consent copy is shown (it would no longer be true). */
(() => {
  const ALLOWED = [/^https:\/\/www\.google\.com\/maps\/embed/i, /^https:\/\/maps\.google\.com\/maps\?/i];

  // Start fetching a little before the block is actually on screen, so the
  // map is usually painted by the time it is scrolled to.
  const ROOT_MARGIN = '300px';

  const load = (root) => {
    if (root.dataset.pjMapLoaded === '1') return;

    const box = root.querySelector('[data-pj-map-box]');
    const src = (root.dataset.embedSrc || '').trim();
    if (!box || !ALLOWED.some((re) => re.test(src))) return;

    root.dataset.pjMapLoaded = '1';

    const frame = document.createElement('iframe');
    frame.src = src;
    frame.title = root.dataset.mapTitle || '';
    frame.loading = 'lazy';
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.allowFullscreen = true;
    frame.className = 'pj-store-local__frame';

    box.replaceChildren(frame);
  };

  const init = (root) => {
    if (root.dataset.pjMapReady === '1') return;
    root.dataset.pjMapReady = '1';

    // No observer (old browser): load right away rather than never.
    if (typeof IntersectionObserver !== 'function') {
      load(root);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        load(root);
      },
      { rootMargin: ROOT_MARGIN }
    );

    observer.observe(root);
  };

  const initAll = () => document.querySelectorAll('[data-pj-store-map]').forEach(init);

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
